import Vue from "vue";
import Vuex, { Store } from "vuex";
import { vuexfireMutations, firestoreAction, firebaseAction } from 'vuexfire'
import createPersistedState from "vuex-persistedstate";
import SecureLS from "secure-ls";
import User from "@/store/modules/user";
import db from "@/db";
Vue.use(Vuex);

const ls = new SecureLS({ isCompression: false });
const store : Store<any> = new Vuex.Store({
    strict: false,
    modules: {
        User
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key)
            }
        })
    ],
    state: {
        oportunities: [],
        selectedOportunity: null,
        cvs: null,
        interviews: null,
        selectedInterview: null,
        selectedCv: null
    },
    mutations: {
        ...vuexfireMutations
    },
    actions: {
        updateUser({ commit }, { user }) {
            console.log("updateUser:" + JSON.stringify(user));
            this.dispatch("User/updateUser", user);
        },
        bindOportunities: firestoreAction(({ bindFirestoreRef }) => {
          // return the promise returned by `bindFirestoreRef`
          return bindFirestoreRef('oportunities', db.collection('oportunities'))
        }),
        bindSelectedOportunity: firestoreAction(({ bindFirestoreRef }, { oportunityId }) => {
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('selectedOportunity', db.collection('oportunities').doc(oportunityId))
        }),
        bindCvs: firestoreAction(({ bindFirestoreRef }, {userId, oportunityId}) => {
          // return the promise returned by `bindFirestoreRef`
          console.log("UserId: " + userId + " OId: " + oportunityId)
          return bindFirestoreRef('cvs', 
            db.collection('users')
              .doc(userId)
              .collection('oportunities')
              .doc(oportunityId)
              .collection('cvs')
              .orderBy('createdAt', 'desc')
          )
        }),
        bindInterviews: firestoreAction(({ bindFirestoreRef }, {oportunityId, track}) => {
            // return the promise returned by `bindFirestoreRef`
            console.log(" OId: " + oportunityId + " Track: " + track)
            return bindFirestoreRef('interviews', 
              db.collection('oportunities')
                .doc(oportunityId)
                .collection('interviews')
                .where("track", "==", track)
                .limit(1)
            )
        }),
        bindSelectedInterview: firestoreAction(({ bindFirestoreRef }, { interviewId }) => {
            console.log("selectedInterview interviewId: " + interviewId);
            // return the promise returned by `bindFirestoreRef`
            return bindFirestoreRef('selectedInterview', db.collection('interviews').doc(interviewId))
        }),
        bindSelectedCv: firestoreAction(({ bindFirestoreRef }, { userId, oportunityId, cvId }) => {
            return bindFirestoreRef('selectedCv', db.collection("users")
                .doc(userId)
                .collection("oportunities")
                .doc(oportunityId)
                .collection("cvs").doc(cvId))
        }),
    }
});
export default store;
